const unit = document.querySelector('.c-units__inner');
let unitItems = document.querySelectorAll('.c-unit');
const dots = document.querySelectorAll('.c-units__paged .dot');
const itemsPerPage = 3; // Number of items per page

const changeItems = (item) => {
    if (item.classList.contains('even')) {
        item.classList.remove('even');
        item.classList.add('odd');
    } else {
        item.classList.remove('odd');
        item.classList.add('even');
    }
};

const centerItems = (item) => {
    item.addEventListener('click', () => {
        if (item.classList.contains('active')) {
            return;
        }

        unitItems.forEach((item) => {
            item.classList.remove('active');
            changeItems(item);
        });

        item.classList.add('active');
    });
};

// Update the slider to show items for the selected page
const goToPage = (page) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    // Fade out current items
    unitItems.forEach((item) => {
        item.style.opacity = '0';
    });

    setTimeout(() => {
        unitItems.forEach((item, index) => {
            if (index >= startIndex && index < endIndex) {
                item.style.display = 'block'; // Show items for the current page
                setTimeout(() => {
                    item.style.opacity = '1'; // Fade in
                }, 10); // Small delay for transition
            } else {
                item.style.display = 'none'; // Hide other items
            }
        });

        // Update active dot
        dots.forEach((dot) => dot.classList.remove('active'));
        if (dots[page - 1]) {
            dots[page - 1].classList.add('active');
        }

        setEqualHeight(); // Ensure heights are set after items are shown/hidden
    }, 300); // Match the CSS transition duration
};


// Initialize pagination
const initializePagination = () => {
    if (dots.length > 0) {
        dots.forEach((dot) => {
            dot.addEventListener('click', () => {
                const page = parseInt(dot.getAttribute('data-page'), 10);
                goToPage(page);
            });
        });

        // Start with the first page
        goToPage(1);
    }
};

// Initialize the slider on page load
if (unit && unitItems) {
    unitItems.forEach((item) => {
        centerItems(item);
    });

    initializePagination();
}

const setEqualHeight = () => {
    // Only set heights, don't change visibility
    const units = document.querySelectorAll('.c-unit');
    let maxHeight = 0;

    // Temporarily show all units to measure them
    units.forEach((unit) => {
        unit.style.height = 'auto'; // Reset height to natural
        if (unit.style.display === 'none') {
            unit.style.display = 'block';
            unit.dataset.tempHidden = 'true';
        }
    });

    // Find the tallest height across all units
    units.forEach((unit) => {
        const height = unit.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
    });

    // Apply the tallest height to all units
    units.forEach((unit) => {
        unit.style.height = `${maxHeight}px`;
    });

    // Re-hide units that were temporarily shown
    units.forEach((unit) => {
        if (unit.dataset.tempHidden === 'true') {
            unit.style.display = 'none';
            delete unit.dataset.tempHidden;
        }
    });
};

// Call the function on page load and resize
window.addEventListener('load', setEqualHeight);
window.addEventListener('resize', setEqualHeight);

// Call after each page change
dots.forEach((dot) => {
    dot.addEventListener('click', () => {
        setTimeout(setEqualHeight, 300); // Wait for page transition
    });
});
